export default {
  station_comment_reply: {
    name: '评论回复',
    prop: {
      content: '回复内容',
      status: '状态',
      station_comment: '点评原文',
      created_at: '回复创建时间',
      person: '点评人',
      ev_charging_station_id: '充电站',
      user_id: '点评用户',
      admin_id: '点评管理员'
    },
    columns: {
      created_at: '回复创建时间'
    },
    placeholder: {
      search_keyword: '回复内容'
    },
    titles: {
      original_station_comment: '评论原文详情'
    }
  }
}
